import BoxInfo from '@/components/boxInfo/boxInfo';
import IconBox from '@/components/iconBox';
import { analytics } from '@/shared/telemetry/analytics/analytics';
import React from 'react';
import { Button, Text } from 'vkit/lib/components';
import { Grid } from 'vkit/lib/context';

interface CardInsightsProps {
  iconImageUrl?: string;

  title?: string;
  message?: string;

  buttonLink?: string;
  buttonLabel?: string;
  buttonIcon?: string;
  buttonIconDir?: 'left' | 'right';
  buttonEventName?: string;

  padding?: number | string;
}

export const CardInsights: React.FC<CardInsightsProps> = ({
  iconImageUrl,
  title,
  message,
  buttonLink,
  buttonLabel,
  buttonIcon,
  buttonIconDir,
  buttonEventName,
  padding,
}) => {
  return (
    <BoxInfo padding={padding}>
      <Grid alignContent='justify' alignItems='center'>
        <Grid gap={16} alignItems='center'>
          <IconBox iconImageUrl={iconImageUrl} />

          <Grid column alignContent='center'>
            {title && <Text title value={title} color='colorDefault' />}

            {message && <Text size='medium' value={message} />}
          </Grid>
        </Grid>

        <div style={{ minWidth: 200, display: 'flex', justifyContent: 'right' }}>
          <Button
            label={buttonLabel}
            icon={buttonIcon}
            iconDir={buttonIconDir}
            onClick={() => {
              buttonEventName && analytics.track(buttonEventName, { label: buttonLabel });
              window.open(buttonLink || '', 'new');
            }}
          />
        </div>
      </Grid>
    </BoxInfo>
  );
};
